import { useCallback, useEffect, useState } from 'react'


export function useIsDataNotValid() {
  const [isDataNotValid, setIsDataNotValid] = useState(false)

  useEffect(() => {
    if (isDataNotValid) {
      setIsDataNotValid(false)
    }
  }, [isDataNotValid])

  const handleInvalidateData = useCallback(() => { setIsDataNotValid(true) }, [])

  return [isDataNotValid, handleInvalidateData] as const
}
